import React from 'react';
import { Helmet } from 'react-helmet-async';
import History from '../components/sections/about/History';
import Team from '../components/sections/about/Team';
import Achievements from '../components/sections/about/Achievements';
import { vision } from '../data/team';

const About: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>O nas | Oljarna Krajnc</title>
        <meta 
          name="description" 
          content="Spoznajte zgodbo Oljarne Krajnc, našo bogato tradicijo in ljudi, ki z ljubeznijo pridelujejo najboljše bučno olje že od leta 1927."
        />
      </Helmet>
      
      <section className="pt-32 pb-16 bg-[url('/images/about-hero-bg.jpg')] bg-cover bg-center relative">
        <div className="absolute inset-0 bg-primary-700 opacity-70"></div>
        <div className="container-wide relative z-10 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            O nas
          </h1>
          <div className="w-24 h-1 bg-secondary mx-auto mb-8"></div>
          <p className="text-white text-lg md:text-xl max-w-3xl mx-auto">
            Spoznajte zgodbo Oljarne Krajnc, našo bogato tradicijo in ljudi,
            ki z ljubeznijo pridelujejo najboljše bučno olje že od leta 1927.
          </p>
        </div>
      </section>
      
      <History />
      
      <section className="py-16 bg-white">
        <div className="container-wide">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="/images/vision-image.jpg" 
                alt="Naša vizija" 
                className="rounded-lg shadow-xl"
              />
            </div>
            
            <div>
              <h6 className="text-secondary font-semibold mb-2">NAŠA VIZIJA</h6>
              <h2 className="text-3xl md:text-4xl font-bold text-primary-700 mb-4">
                {vision.title}
              </h2>
              <div className="w-16 h-1 bg-secondary mb-6"></div>
              <p className="text-accent-700 text-lg">
                {vision.content}
              </p>
              
              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <div className="flex items-center">
                  <div className="flex-shrink-0 mr-4">
                    <div className="bg-primary-50 p-3 rounded-full">
                      <img 
                        src="/images/icons/organic.svg" 
                        alt="Organic" 
                        className="w-8 h-8"
                      />
                    </div>
                  </div>
                  <div>
                    <h4 className="font-semibold text-primary-700">100% Naravno</h4>
                    <p className="text-sm text-accent-700">Brez umetnih dodatkov</p>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <div className="flex-shrink-0 mr-4">
                    <div className="bg-primary-50 p-3 rounded-full">
                      <img 
                        src="/images/icons/quality.svg" 
                        alt="Quality" 
                        className="w-8 h-8"
                      />
                    </div>
                  </div>
                  <div>
                    <h4 className="font-semibold text-primary-700">Premium kakovost</h4>
                    <p className="text-sm text-accent-700">Certificirano</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Team />
      
      <Achievements />
    </>
  );
};

export default About;